import { catchError } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { APP_CONFIG, IAppConfig } from './../../app.config';
import { MessageService } from './message.service';

@Injectable()
export class AuthenticationClient {
  constructor(
    private _client: HttpClient,
    private _messageService: MessageService,
    @Inject(APP_CONFIG) private _config: IAppConfig
  ) {}

  authenticate(login: string, password: string): Observable<any> {
    const body = {
      grant_type: 'client_credentials',
      username: login,
      password: password
    };

    return this._client
      .post<any>(this._config.tokenEndpoint, body).pipe(
        catchError((errorResponse: HttpErrorResponse) => {
          if (errorResponse.error) {
            if (errorResponse.error.error === 'invalid_grant') {
              throw new Error('ERROR.AUTHENTICATION');
            } else {
              this._messageService.showError(errorResponse);
            }
          }
          throw new Error();
        }
      ));
  }

  authenticateBankId(referenceId: string): Observable<any> {
    const body = {
      grant_type: 'bankid_credentials',
      order_reference: referenceId
    };

    return this._client
      .post<any>(this._config.tokenEndpoint, body).pipe(
        catchError((errorResponse: HttpErrorResponse) => {
          if (errorResponse.error) {
            if (errorResponse.error.error === "invalid_grant") {
              throw new Error('ERROR.AUTHENTICATION');
            } else {
              this._messageService.showError(errorResponse);
            }
          }
          throw new Error();
        }
      ));
  }

  // authenticate(login: string, password: string): Observable<any> {
  //   let encodedLogin = encodeURIComponent(login);
  //   let encodedPassword = encodeURIComponent(password);

  //   return this._client
  //     .post<any>(this._config.tokenEndpoint, `userName=${encodedLogin}&password=${encodedPassword}&grant_type=password`).pipe(
  //       catchError((errorResponse: HttpErrorResponse) => {
  //         if (errorResponse.error) {
  //           if (errorResponse.error.error === "invalid_grant") {
  //             throw new Error('ERROR.AUTHENTICATION');
  //           } else {
  //             this._messageService.showError(errorResponse);
  //           }
  //         }
  //         throw new Error();
  //       }));
  // }

  // authenticateBankId(referenceId: string): Observable<any> {
  //  const parameters = `client_id=LandlordPages&client_secret=${referenceId}&code=${referenceId}&grant_type=authorization_code&redirect_uri${encodeURIComponent('/')}`;
  //  return this._client.post<any>(this._config.tokenEndpoint, parameters).pipe(
  //      catchError(() => {
  //          this._messageService.showError('LOGIN_FORM.BANKID_SIGN_IN_FAILED');
  //          throw new Error();
  //      })
  //  );
  //}
}
